import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreConfigService } from "../../../@core/services/config.service";
import { locale as taskIt } from "./i18n/taskIt";
import taskMenu from "./task.menu";
import { RouterModule } from "@angular/router";
import taskRoutes from "./task.routes";
import { AllTodoListComponent } from "./pages/all-todo-list/all-todo-list.component";
import { TodoListComponent } from "./pages/todo-list/todo-list.component";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { CoreCommonModule } from "../../../@core/common.module";
import { ModalAddTaskComponent } from "./components/modal-add-task/add-task.component";
import { ViewTaskComponent } from "./components/modal-view-task/view-task.component";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { CoreCardModule } from "../../../@core/components/core-card/core-card.module";
import { MyTaskComponent } from "./components/widget-my-task/my-task.component";
import { customBreakPointsProvider } from "../../layout/custom-breakpoints";
import { NgbDropdownModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { LayoutModule } from "../../layout/layout.module";

@NgModule({
  declarations: [AllTodoListComponent, TodoListComponent, ViewTaskComponent, ModalAddTaskComponent, MyTaskComponent],
  imports: [
    CoreCardModule,
    CommonModule,
    ContentHeaderModule,
    RouterModule.forChild(taskRoutes),
    NgSelectModule,
    TranslateModule,
    CoreCommonModule,
    PerfectScrollbarModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgxDatatableModule,
    Ng2FlatpickrModule,
    AngularEditorModule,
    LayoutModule,
  ],
  providers: [customBreakPointsProvider],
  exports: [MyTaskComponent, ModalAddTaskComponent],
})
export class TaskModule {
  constructor(private _coreConfigService: CoreConfigService) {
    // prendiamo la configurazione corrente, aggiungiamo alla chiave custom.languages le traduzioni di billing e poi andiamo ad aggiornare
    this._coreConfigService.getConfig().subscribe((data: any) => {
      const installedPackages: string[] = data.custom.installed_packages || [];

      if (!installedPackages.includes("task")) {
        const currentLanguages: any = data.custom.languages || [];
        const currentMenu: any = data.custom.menu || [];
        currentLanguages.push(taskIt);
        currentMenu.push(taskMenu);
        installedPackages.push("task");
        this._coreConfigService.setConfig({ custom: { languages: currentLanguages, menu: currentMenu, installed_packages: installedPackages } }, { emitEvent: true });
      }
    });
  }
}
